import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import Router from "next/router";
import { connect } from "react-redux";
import { HOME } from "../../routes/RouteConstants";
import GoToJobs from "../../containers/Profile/components/GoToJobs";
import LogService from "../../services/LogService";
import CommonEvents from "../../utils/commonEvents";

const styles = theme => ({
  root: {
    flex: "0 0 auto",
    "-webkit-tap-highlight-color": "transparent",
    display: "flex",
    alignItems: "center"
  },
  logo: {
    float: "left",
    width: "134px",
    height: "39px",
    cursor: "pointer",
    ["@media (max-width:576px)"]: {
      display: "none"
    }
  },
  logoMobile: {
    float: "left",
    width: "37px",
    height: "33px",
    cursor: "pointer",
    ["@media (min-width:577px)"]: {
      display: "none"
    }
  },
  mobileBack: { ["@media (min-width:577px)"]: { display: "none" } },
  seperator: {
    display: "inline-block",
    borderLeft: "1px solid #979797",
    marginLeft: "10px",
    height: "41px",
    ["@media (max-width:576px)"]: {
      height: "30px"
    }
  },
  span: {
    ...theme.typography.defaultFont,
    fontWeight: 600,
    display: "inline-block",
    fontSize: "12px",
    lineHeight: "16px",
    margin: "4px 0 0 10px",
    ["@media (max-width:576px)"]: {
      fontSize: "10px",
      lineHeight: "12px"
    }
  }
});

class Logo extends Component {
  render() {
    const { classes, isClick, isBack = false, deviceType } = this.props;
    const isMobile = deviceType === "mobile";
    return (
      <div
        onClick={
          isClick
            ? () => {
                LogService.log(CommonEvents.NAV_LOGO_CLICKED);
                window.location.href = `${process.env.LIVE_URL_HIRE}`;
              }
            : null
        }
        className={classes.root}
      >
        {!isMobile ? (
          <img
            src={`/hire/recruiter-logo.svg`}
            className={classes.logo}
            alt="jobhai.com"
            width={"134px"}
            height={"39px"}
          />
        ) : null}
        {isBack ? (
          <div className={classes.mobileBack}>
            <GoToJobs />
          </div>
        ) : isMobile ? (
          <img
            src={`/hire/logo-mobile.svg`}
            className={classes.logoMobile}
            alt="jobhai.com"
            width={"37px"}
            height={"33px"}
          />
        ) : null}
        {/* <span className={classes.seperator}>
          <span className={classes.span}>
            A Naukri Group <br />
            company
          </span>
        </span> */}
      </div>
    );
  }
}

Logo.propTypes = {
  classes: PropTypes.object.isRequired,
  isClick: PropTypes.bool,
  isBack: PropTypes.bool
};

const mapStateToProps = state => ({
  deviceType: state.commonReducer.deviceType
});

export default connect(mapStateToProps, null)(withStyles(styles)(Logo));
